enum Timezone {
    UTC = 'UTC',
    AFRICA_CASABLANCA = 'Africa/Casablanca',
}

export default Timezone;
